import useInput from "hooks/useInput";
import { Input as IParqueInput } from "iparque-components";
import React, { InputHTMLAttributes } from "react";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
  required?: boolean;
}

const Input: React.FC<Props> = ({
  type,
  required,
  id,
  name,
  label,
  ...props
}) => {
  const { field, meta, hasError } = useInput(name);

  return (
    <IParqueInput
      type={type}
      id={id}
      label={label}
      error={hasError}
      required={required}
      helperText={hasError ? meta.error : ""}
      {...field}
      {...props}
    />
  );
};

export default Input;
